import { FC } from 'react';
import classNames from 'classnames';

export interface Props {
  label: string;
  toggled?: boolean;
  offLabel?: string;
  onLabel?: string;
  onSwitchChange: (toggled: boolean) => void;
  className?: string;
}

const Switch: FC<Props> = ({
  label,
  toggled = false,
  offLabel = 'Off',
  onLabel = 'On',
  onSwitchChange = () => null,
  className,
}) => {
  const classnames = classNames(
    'switch',
    {
      'switch--on': !!toggled,
      'switch--off': !toggled,
    },
    className
  );

  const handleSwitchChange = event => {
    event.preventDefault();
    onSwitchChange(toggled);
  };

  return (
    <div className={classnames} data-testid="switch">
      {!!label && (
        <div className="switch__label" data-testid="switchLabel">
          {label}
        </div>
      )}
      <button
        className="switch__button"
        data-testid="switchButton"
        onClick={handleSwitchChange}
      >
        <span className="switch__text">{toggled ? onLabel : offLabel}</span>
      </button>
    </div>
  );
};

export default Switch;
